<template>
  <div
    class="m-spacing"
    :class="{
      [`m-spacing--top-${top}`]: top !== '',
      [`m-spacing--right-${right}`]: right !== '',
      [`m-spacing--bottom-${bottom}`]: bottom !== '',
      [`m-spacing--left-${left}`]: left !== '',
      'm-spacing--inline': inline,
      'm-spacing--responsive': responsive,
    }"
  >
    <slot />
  </div>
</template>

<script>
/**
 * Add spacing around or between elements with the option to increase it on desktop
 */
export default {
  name: 'm-spacing',
  props: {
    top: {
      type: String,
      required: false,
      default: '',
    },
    right: {
      type: String,
      required: false,
      default: '',
    },
    bottom: {
      type: String,
      required: false,
      default: '',
    },
    left: {
      type: String,
      required: false,
      default: '',
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Responsive spacing bumps up by one size
     * on desktop and tablet.
     */
    responsive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use 'sass:list';
@use '../../../sass/framework/variables/spacing';
@use '../../../sass/framework/mixins/breakpoint';

$directions: ('top' 'right' 'bottom' 'left');

// .m-spacing--[top|right|bottom|left]-[xxxs|xxs|xs|sm|md|lg|xl|xxl|xxxl]
.m-spacing {
  @each $direction in $directions {
    &--#{$direction} {
      @each $key, $value in spacing.$sizes {
        &-#{$key} {
          margin-#{$direction}: $value;

          @include breakpoint.breakpoint(tablet-up) {
            // Bump spacing up by one on tablet/desktop
            // if using responsive spacing
            &.m-spacing--responsive {
              $keys: map.keys(spacing.$sizes);
              $index: list.index($keys, $key);
              // Last key just stays the same
              @if ($index <= list.length($keys) - 1) {
                // Otherwise return the next one
                $next-key: list.nth($keys, $index + 1);
                margin-#{$direction}: map.get(spacing.$sizes, $next-key);
              }
            }
          }
        }
      }
    }
  }

  &--inline {
    display: inline;
  }
}
</style>
